import { Grid } from '@mui/material';
import { DELETE_FAQ, GET_FAQ_LIST } from 'src/apiService/apiDeclaration';
import { ICONS } from 'src/assets/library';
import FaqForm from 'src/components/form/faqForm';
import MenuPopover from 'src/components/menu/menu';
import PageHeader from 'src/components/pageHeader/PageHeader';
import TabTitle from 'src/components/tabTitle/tabTitle';
import CustomTable from 'src/components/table/table';
import { showErrorTost, showSuccessTost } from 'src/constants';
import { faqColumns } from 'src/constants/columnConfig';
import { useModal } from 'src/hooks/useModal';
import usePagination from 'src/hooks/usePagination';

const FaqPage = () => {
  const updatedfaqColumn = [...faqColumns];
  const { setDialogData, handleModalClose } = useModal();
  const { paginationModel, setPaginationModel, loading, data, refresh } = usePagination(GET_FAQ_LIST);

  const onSuccess = () => {
    handleModalClose();
    refresh();
  };

  const onDelete = async (id) => {
    try {
      await DELETE_FAQ(id);
      onSuccess();
      showSuccessTost('FAQ deleted successfully');
    } catch (error) {
      console.log(error);
      showErrorTost('Error in deleting FAQ');
    }
  };

  updatedfaqColumn.push({
    field: 'action',
    headerName: 'Action',
    sortable: false,
    disableColumnMenu: true,
    width: 80,
    renderCell: ({ row }) => {
      return (
        <MenuPopover
          menuArray={[
            {
              icon: ICONS.edit,
              name: 'Edit faq',
              action: () => {
                setDialogData({
                  showModal: true,
                  title: 'Update FAQ',
                  child: <FaqForm data={row} onSuccess={onSuccess} />,
                });
              },
            },
            {
              icon: ICONS.delete,
              name: 'Delete Permanentaly',
              action: () => {
                setDialogData({
                  showModal: true,
                  description: 'Are you sure you want to delete this FAQ?',
                  onConfirm: () => onDelete(row._id),
                });
              },
            },
          ]}
        />
      );
    },
  });

  return (
    <Grid container spacing={2}>
      <TabTitle title={'FAQ'} />
      <Grid item xs={12}>
        <PageHeader
          pageTitle={'FAQ'}
          buttonTitle={'Add FAQ'}
          onButtonClick={() =>
            setDialogData({
              showModal: true,
              title: 'Add new FAQ',
              child: <FaqForm onSuccess={onSuccess} />,
            })
          }
        />
      </Grid>
      <Grid item xs={12}>
        <CustomTable
          loading={loading}
          isServerSidePagination
          paginationModel={paginationModel}
          setPaginationModel={setPaginationModel}
          columns={updatedfaqColumn}
          rows={data.rows}
          rowCount={data.rowCount}
        />
      </Grid>
    </Grid>
  );
};

export default FaqPage;
